import { signInAnonymously, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { getUserId } from './userId';

const uidMapDoc = (uid) => doc(db, 'uid_map', uid);

// Retorna o userId legado mapeado para este uid anônimo, ou cria o mapeamento
const resolveUserId = async (uid) => {
  const snap = await getDoc(uidMapDoc(uid));
  if (snap.exists()) {
    return snap.data().userId;
  }
  // Primeiro acesso deste uid: mapeia para o userId legado do localStorage
  const legacyUserId = getUserId();
  await setDoc(uidMapDoc(uid), { userId: legacyUserId, createdAt: Date.now() });
  return legacyUserId;
};

// Inicializa auth anônima e retorna o userId legado associado
// Retorna null se offline (app continua com localStorage)
export const initAuth = () =>
  new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      unsubscribe();
      try {
        const currentUser = user || (await signInAnonymously(auth)).user;
        const userId = await resolveUserId(currentUser.uid);
        resolve(userId);
      } catch {
        // Offline ou falha no auth: resolve com userId local
        resolve(getUserId());
      }
    });
  });

// Atualiza o mapeamento uid → userId (usado no fluxo de recuperação)
export const remapAuthToUserId = async (newUserId) => {
  try {
    const uid = auth.currentUser?.uid;
    if (uid) {
      await setDoc(uidMapDoc(uid), { userId: newUserId, updatedAt: Date.now() });
    }
  } catch {
    // falha silenciosa — o userId já foi atualizado no localStorage
  }
};
